<template>
  <div class="JSON-to-CSV">
    <a v-if="!loading" :href="csv_object" :download="toWindowsFilename(filename)+'.csv'">{{text}}</a>
    <DataPlaceholder class="placeholder" v-else/>
  </div>
</template>

<script>
import DataPlaceholder from '@/components/DataPlaceholder.vue' 
export default {
  name: 'JSONToCSV',
  components: {
    DataPlaceholder,
  },
  props: {
    loading: Boolean,
    text: {
      type: String,
      default: 'Download'
    },
    delimiter: {
      type: String,
      default: ';'
    },
    columns: {
      type: Array,
      default: ()=>[],
    },
    data: {
      type: Array,
      default: ()=>[],
    },
    filename: {
      type: String,
      default: 'mportal_file'
    }
  },
  computed: {
    csv_object() {
      const csv_head = 'data:text/csv;charset=utf-8,'
      var csv_content = ''
      const newline = "\r\n"
      if(!this.columns || !this.data) {
        return null
      }
      csv_content += this.columns.map(column=>column.name).join(this.delimiter)+newline
      this.data.forEach(row=>{
        const values = []
        this.columns.forEach(column=>{
          var value = this.getEntry(row,column)
          if(typeof value ==='string') {
            value = `"${value}"`
            // value = value.replace('\\r\\n', ' ')
          }
          values.push(value)
        })
        csv_content += values.join(this.delimiter)+newline
      })
      const encodedURI = encodeURIComponent(csv_content)
      return csv_head + encodedURI
    }
  },
  methods: {
    toWindowsFilename(filename) {
      if(!filename) {
        return "mportal_file"
      }
      const invalid_characters = [
        "#",
        "%",
        "&",
        "{",
        "}",
        "\\",
        "<",
        ">",
        "*",
        "?",
        "/",
        " ",
        "$",
        "!",
        "'",
        '"',
        ":",
        "@",
        "+",
        "`",
        "|",
        "=",
      ]
      invalid_characters.forEach(character=>{
        filename.replace(character, "_")
      })
      return filename.split(" ").join("_")
    },
    getEntry(row, column) {
      if(column.nested && Array.isArray(column.id)) {
        var value = row
        column.id.forEach(sub_id=>{
          if(value===null) {
            return
          }
          value = value[sub_id]
        })
        return value
      }

      return row[column.id]
    },
  }
}
</script>

<style lang="scss" scoped>
@import 'D:\\inetpub\\MPortal\\src\\_variables';
.placeholder {
  transform: scale(0.5) !important;
}
.JSON-to-CSV {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  a {
    height: 100%;
    display: inline-block;
    aspect-ratio: 21/9;
    cursor: pointer;
    border: 1px solid gray;
    color: gray;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }
  a:link {
    border: 1px solid $text_dark;
    color: $text_dark;
    &:hover {
      background-color: $text_dark;
      color: $text_light;
    }
  }
}
</style>